/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AnagraficaViewImpl } from './anagraficaViewImpl';
import { ComuneViewImpl } from './comuneViewImpl';
import { GetScuolaNomePlessoView } from './getScuolaNomePlessoView';
import { StoricoIseeView } from './storicoIseeView';
import { UserType } from './userType';

export interface UserViewImpl { 
    id?: string;
    codiceFiscaleHash?: string;
    userType?: UserType;
    email?: string;
    accountActivated?: boolean;
    accountEnabled?: boolean;
    anagrafica?: AnagraficaViewImpl;
    scuoleGestite?: Array<GetScuolaNomePlessoView>;
    comuniGestiti?: Array<ComuneViewImpl>;
    storicoIsee?: Array<StoricoIseeView>;
    fullname?: string;
}